import React, {Component} from 'react'
import {connect} from 'react-redux'
import autobind from 'autobind-decorator'

import If from "../../../common/control/If";
import NoneCustomDomainForm from './customDomain/NoneCustomDomainForm'
import RegisterCustomDomainForm from "./customDomain/RegisterCustomDomainForm";
import CustomDomainStatusForm from "./customDomain/CustomDomainStatusForm";
import ModifyCustomDomainForm from "./customDomain/ModifyCustomDomainForm";

@connect(state => ({
    address: state.setting.blog.address
}), dispatch => ({
    dispatch
}))
class BlogCustomDomainForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = Object.assign({
            openRegisterForm : false ,
            openModifyForm : false ,
        }, props.address)
    }

    @autobind
	  handleToggleRegisterForm() {
        const { openRegisterForm } = this.state;
        this.setState({
            openRegisterForm: !openRegisterForm
        })
	  }

    @autobind
	  handleToggleModifyForm() {
        const { openModifyForm } = this.state;
        this.setState({
            openModifyForm: !openModifyForm
        })
	  }

    render() {
        const domainRegistered = this.props.address.useSecondaryDomain;

        const { openRegisterForm, openModifyForm } = this.state

        return (
          <form className="wrap_set" onSubmit={this.handleSubmit}>
            <If condition={!domainRegistered && !openRegisterForm} >
              <NoneCustomDomainForm openRegisterForm={this.handleToggleRegisterForm}/>
            </If>
            <If condition={!domainRegistered && openRegisterForm} >
              <RegisterCustomDomainForm closeRegisterForm={this.handleToggleRegisterForm}/>
            </If>
            <If condition={domainRegistered && !openModifyForm} >
              <CustomDomainStatusForm openModifyForm={this.handleToggleModifyForm} />
            </If>
            <If condition={domainRegistered && openModifyForm} >
              <ModifyCustomDomainForm closeModifyForm={this.handleToggleModifyForm} />
            </If>
          </form>
        )
    }
}

export default BlogCustomDomainForm
